export const STAGES = [
  ["new", "New", "bg-sky-50 text-sky-700 border-sky-200"],
  ["called", "Called", "bg-amber-50 text-amber-700 border-amber-200"],
  ["member", "Member", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  ["customer", "Customer", "bg-[#0F382C] text-white border-[#0F382C]"],
  ["lost", "Lost", "bg-slate-100 text-slate-500 border-slate-200"],
];
export const STAGE = Object.fromEntries(STAGES.map(([k, l, t]) => [k, { label: l, tone: t }]));
export const OUTCOMES = [["interested", "Interested"], ["call_back", "Call back"], ["no_answer", "No answer"], ["not_interested", "Not interested"]];
export const OUTCOME = Object.fromEntries(OUTCOMES);
export const SEG_TONE = { B2C: "bg-[#D96B43]/10 text-[#B4522E]", B2B: "bg-sky-50 text-sky-700", B2P: "bg-violet-50 text-violet-700" };

export const StagePill = ({ stage, testid }) => (
  <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${STAGE[stage]?.tone || ""}`} data-testid={testid}>{STAGE[stage]?.label || stage}</span>
);

export const SegBadge = ({ seg, testid }) => seg ? <span className={`rounded px-1.5 py-0.5 font-mono text-[10px] font-bold ${SEG_TONE[seg]}`} data-testid={testid}>{seg}</span> : null;
